import React from 'react';

export const useSticky = (width: number,lastElementId:string ,childElementId: string, footerId: string) => {
  if (typeof window != 'undefined') {
    const sideBar = document.getElementById(childElementId);
    const footer = document.getElementById(footerId);
    const breadCrumb = document.getElementById(lastElementId);

    if (!sideBar || !footer || !breadCrumb) {
      return;
    }

    let sideBarHeight = sideBar.offsetHeight || 171;
    let sideBarTop = sideBar.offsetTop || 0;
    let footerTop = footer.offsetTop || 2522;
    let maximumYPosition = footerTop - sideBarHeight;
    const breadCrumbBottom = breadCrumb.offsetTop + breadCrumb.offsetHeight || 170;

    window.addEventListener('resize', () => {
      sideBarHeight = sideBar.offsetHeight || 171;
      sideBarTop = sideBar.offsetTop || 0;
      footerTop = footer.offsetTop || 2522;
      maximumYPosition = footerTop - sideBarHeight;
    });

    window.addEventListener('scroll', () => {
      const scrollTop = window.scrollY;

      if (scrollTop > breadCrumbBottom) {
        if (scrollTop < maximumYPosition - 111) {
          if (width > 768) {
            sideBar.style.position = 'fixed';
            sideBar.style.top = '1.25rem';
            sideBar.style.left = 'unset';
          } else {
            sideBar.style.top = '0';
            sideBar.style.left = '0';
          }
        } else {
          if (width > 768) {
            sideBar.style.left = 'unset';
            sideBar.style.position = 'absolute';
            sideBar.style.top = maximumYPosition - sideBarTop + 'px';
          }
        }
      } else {
        if (width > 768) {
          sideBar.style.position = 'initial';
          sideBar.style.top = 'initial';
          sideBar.style.left = 'unset';
        }
      }
    });
  }
};
